import React, { useCallback, useEffect, useRef, useState } from "react";

// import { FaPlus } from "react-icons/fa";
// import { useNavigate } from "react-router-dom";

// import { AiFillEdit, AiFillEye } from "react-icons/ai";
// import { FiDelete, FiEdit } from "react-icons/fi";
import { getSector } from "helper";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import MDBox from "components/MDBox";
import { Card, Grid } from "@mui/material";
import SearchBar from "components/SearchBar";
import CustomTable from "components/CustomTable";
import { _postApi } from "redux/action/api";
import Footer from "examples/Footer";
import MDTypography from "components/MDTypography";
import { _fetchApi } from "redux/action/api";
import Scrollbar from "components/Tree/Scrollbar";
import {
  Button,
  Input,
  // Modal,
  // ModalBody,
  // ModalHeader,
  Label,
  Spinner,
  // Row,
  // Col,
  // Table,
} from "reactstrap";
import { formatNumber } from "redux/action/api";
import CustomTypeahead from "components/CustomTypeahead";
// import { today } from "helper";
import { year } from "helper";
// import { useSelector } from "react-redux";
import { useToasts } from "helper/ToastAdapter";
import { useYear } from "useYearList";
// import { checkIfNull } from "redux/action/api";
// import { bg } from "redux/action/api";
import { FaEye } from "react-icons/fa";
import { MdPrint } from "react-icons/md";
// import { useNavigate } from "react-router-dom";
import { today, weekAgo } from "redux/action/api";
import { ensureNumber } from "redux/action/api";
import moment from "moment";

function ReleaseReport() {
  const years = useYear();
  const { addToast } = useToasts();
  const [form, setForm] = useState({
    budget_year: year,
    economic_code: "",
    economic_description: "",
    program_code: "",
    program_description: "",
    function_code: "",
    function_description: "",
    fund_code: "",
    fund_description: "",
    geo_code: "",
    geo_description: "",
    budget_amount: "",
    actual_amount: "",
    budget_type: "",
    date_from: weekAgo,
    date_to: today,
    segment: "",
    approval_type: "",
    sector_type: "",
  });
  const [searchText, setSearchText] = useState("");
  const [results, setResults] = useState();
  const [loading, setLoading] = useState(false);
  const [print, setPrint] = useState(false);
  const [showBulkPreview, setShowBulkPreview] = useState(false);
  const [isPrinting, setIsPrinting] = useState(false);
  const [results4, setResult4] = useState([]);

  const handleSearchChange = (event) => {
    setSearchText(event.target.value);
  };

  const fields = [
    {
      title: "Release Date",
      custom: true,
      component: (ite) => (
        <div> {moment(ite.approval_date).format("DD-MM-YYYY")}</div>
      ),
    },
    { title: "MDA Code", custom: true, component: (ite) => ite.mda_code },
    {
      title: "MDA Name",
      custom: true,
      component: (ite) => <div> {ite.mda_name}</div>,
    },
    {
      title: "Economic Code",
      custom: true,
      component: (item) => item.economic_code,
    },
    {
      title: "Economic Description",
      custom: true,
      component: (ite) => ite.description_code,
    },

    {
      title: "Program Code",
      custom: true,
      component: (ite) => ite.program_code,
    },
    // {
    //   title: "Program Description",
    //   custom: true,
    //   component: (ite) => ite.program_description,
    // },
    // {
    //   title: "Functional code",
    //   custom: true,
    //   component: (ite) => ite.function_code,
    // },

    // { title: "Geo code", custom: true, component: (ite) => ite.geo_code },
    // {
    //   title: "Geo Description",
    //   custom: true,
    //   component: (ite) => ite.geo_description,
    // },

    {
      title: "Amount (₦)",
      custom: true,
      component: (ite, idx) => (
        <div style={{ float: "right" }}>
          {formatNumber(ensureNumber(ite.amount))}
        </div>
      ),
    },
    {
      title: "Approval status",
      custom: true,
      component: (ite, idx) => <div>{ite.approval_status}</div>,
    },
    {
      title: "Approval No",
      custom: true,
      component: (ite, idx) => <div>{ite.approval_no}</div>,
    },
    // {
    //   title: "MOPB Bal. (₦)",
    //   custom: true,
    //   component: (ite, idx) => (
    //     <div style={{ float: "right" }}>
    //       {formatNumber(ensureNumber(ite.balance))}
    //     </div>
    //   ),
    // },
    // {
    //   title: "Acct. Bal. (₦)",
    //   custom: true,
    //   component: (ite, idx) => (
    //     <div style={{ float: "right" }}>
    //       {formatNumber(ensureNumber(ite.acct_balance))}
    //     </div>
    //   ),
    // },
    // {
    //   title: "Status",
    //   custom: true,
    //   component: (ite, idx) => <div>{ite.payment_status}</div>,
    // },
  ];

  const handleChange = ({ target: { name, value } }) => {
    setForm((p) => ({ ...p, [name]: value }));
  };

  let query_type = form.approval_type === "" ? "reports" : "by_type";

  const getBudgetNew = useCallback(() => {
    setLoading(true);
    _postApi(
      `/releases-reports`,
      { ...form, query_type },
      (res) => {
        setResults(res.results);
        // console.log(res, "DATA");

        setLoading(false);
      },
      (err) => {
        console.log(err);
        setLoading(false);
      },
    );
  }, [
    query_type,
    form.mda_name,
    form.approval_type,
    form.date_from,
    form.date_to,
  ]);

  useEffect(() => {
    getBudgetNew();
  }, [getBudgetNew]);

  const handleChanges = ({ target: { value, name } }) => {
    setForm((p) => ({ ...p, [name]: value }));
  };

  const total = results?.reduce(
    (total, item) => total + parseFloat(item?.amount),
    0,
  );
  // const totalCR = results?.reduce(
  //   (total, item) => total + parseFloat(item?.cr),
  //   0,
  // );
  // const totalMOPBCR = results?.reduce(
  //   (total, item) => total + parseFloat(item?.mob_amount || 0),
  //   0,
  // );

  useEffect(() => {
    getSector({ type: "mdas", sector_type: form.sector_type }, "mdas", (d) => {
      setResult4(d);
    });
  }, [form.sector_type]);

  let aheadData = results4?.map((i) => ({
    head: `${i.head}-${i.description}`,
    description: i.description,
    code: i.head,
  }));

  let data = [];

  results?.forEach((item) => {
    if (
      searchText &&
      ((item.economic_description &&
        item.economic_description
          ?.toLowerCase()
          .indexOf(searchText?.toLowerCase()) === -1) ||
        (item.economic_code &&
          item.economic_code
            ?.toLowerCase()
            .indexOf(searchText?.toLowerCase()) === -1) ||
        (item.mda_code &&
          item.mda_code
            ?.toLowerCase()
            .indexOf(searchText?.toLowerCase()) === -1) ||
        (item.mda_name &&
          item.mda_name
            ?.toLowerCase()
            .indexOf(searchText?.toLowerCase()) === -1))
    )
      return;
    else data.push(item);
  });

  const open = () => {
    setPrint(!print);
  };

  const close = () => {
    setPrint(false);
  };

  // Bulk preview functionality
  const handleBulkPreview = () => {
    if (data.length === 0) {
      addToast("No data to preview", {
        appearance: "warning",
        autoDismiss: true,
      });
      return;
    }

    setShowBulkPreview(true);
  };

  // Render the bulk preview with webview
  const renderBulkPreview = () => {
    return (
      <div>
        {/* Header with back and print buttons */}
        <div
          className="no-print"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "20px",
            backgroundColor: "#f8f9fa",
            borderRadius: "8px",
            marginBottom: "20px",
          }}
        >
          <Button
            color="secondary"
            onClick={() => setShowBulkPreview(false)}
            style={{ fontWeight: 500 }}
          >
            ← Back to Report
          </Button>
          <h5 style={{ margin: 0, color: "#333" }}>
            Release Report Preview - {data.length} Record
            {data.length !== 1 ? "s" : ""}
          </h5>
          <Button
            color="success"
            onClick={() => window.print()}
            style={{
              fontWeight: 500,
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <MdPrint size="18px" />
            Print Report
          </Button>
        </div>

        {/* Render the report in webview format */}
        <div
          id="bulk-print-container"
          style={{ backgroundColor: "#f5f5f5", padding: "20px" }}
          className="print-container"
        >
          <style>{`
            @media print {
              @page {
                margin: 0;
                size: A4;
              }
              body * {
                visibility: hidden;
              }
              #bulk-print-container, #bulk-print-container * {
                visibility: visible;
              }
              #bulk-print-container {
                position: absolute;
                left: 0;
                top: 0;
                width: 100%;
                background: white !important;
                padding: 0 !important;
              }
              .print-page {
                page-break-after: always;
                page-break-inside: avoid;
                margin: 0 !important;
                padding: 0 !important;
                background: white !important;
                display: block !important;
                width: 100% !important;
                height: auto !important;
              }
              .print-page:last-child {
                page-break-after: auto;
              }
              .no-print {
                display: none !important;
              }
              /* Hide any fixed positioned elements that might show download buttons */
              div[style*="position: fixed"] {
                display: none !important;
              }
              /* Hide any overlay buttons */
              button {
                display: none !important;
              }
              /* Ensure clean print output */
              * {
                -webkit-print-color-adjust: exact !important;
                color-adjust: exact !important;
              }
              /* Remove any extra spacing or margins that cause empty pages */
              .print-page > div {
                margin: 0 !important;
                padding: 0 !important;
                background: white !important;
                box-shadow: none !important;
                border: none !important;
              }
              /* Ensure PDF components fill the page properly */
              .print-page > div > div {
                margin: 0 auto !important;
                box-shadow: none !important;
                background: white !important;
                padding: 0 !important;
              }
              /* Remove any container backgrounds and shadows */
              .print-container {
                background: white !important;
                padding: 0 !important;
                margin: 0 !important;
              }
              /* Ensure proper spacing between content */
              .print-page + .print-page {
                margin-top: 0 !important;
                padding-top: 0 !important;
              }
            }
            
            @media screen {
              .print-page {
                margin-bottom: 40px;
              }
              .print-page:last-child {
                margin-bottom: 0;
              }
            }
          `}</style>

          <div className="print-page">
            <div
              style={{
                width: "210mm",
                minHeight: "297mm",
                padding: "30px 40px",
                fontFamily: "Arial, sans-serif",
                fontSize: "11px",
                lineHeight: "1.4",
                backgroundColor: "white",
                margin: "0 auto 20px",
                boxShadow: "0 0 10px rgba(0,0,0,0.1)",
              }}
            >
              {/* Header */}
              <div style={{ textAlign: "center", marginBottom: "20px" }}>
                <img
                  src={require("../../assets/images/pngwing.com.png")}
                  style={{
                    width: "100px",
                    height: "60px",
                    marginBottom: "8px",
                  }}
                  alt="logo"
                />

                <div
                  style={{
                    fontSize: "16px",
                    fontWeight: "bold",
                    marginBottom: "4px",
                  }}
                >
                  MINISTRY OF BUDGET & ECONOMIC PLANNING
                </div>
                <div style={{ fontSize: "12px", marginBottom: "2px" }}>
                  Old Government House Office Complex, Katsina
                </div>
                <div style={{ fontSize: "12px" }}>P.MB 2132, KATSINA</div>
              </div>

              {/* Title */}
              <div
                style={{
                  textAlign: "center",
                  fontWeight: "bold",
                  textDecoration: "underline",
                  fontSize: "14px",
                  marginBottom: "20px",
                }}
              >
                RELEASES REPORT
              </div>

              {/* Date Range */}
              <div style={{ marginBottom: "15px", fontSize: "12px" }}>
                <strong>Period:</strong>{" "}
                {moment(form.date_from).format("DD-MM-YYYY")} to{" "}
                {moment(form.date_to).format("DD-MM-YYYY")}
              </div>

              {/* Summary */}
              <div style={{ marginBottom: "20px", fontSize: "12px" }}>
                <div>
                  <strong>Total DR:</strong> ₦{total?.toLocaleString()}
                </div>
                {/* <div>
                  <strong>Total CR:</strong> ₦{totalCR?.toLocaleString()}
                </div>
                <div>
                  <strong>Total MOPB CR:</strong> ₦
                  {totalMOPBCR?.toLocaleString()}
                </div> */}
                <div>
                  <strong>Total Records:</strong> {data.length}
                </div>
              </div>

              {/* Table */}
              <table
                style={{
                  width: "100%",
                  border: "1px solid black",
                  borderCollapse: "collapse",
                  fontSize: "9px",
                }}
              >
                <thead>
                  <tr style={{ backgroundColor: "#f0f0f0" }}>
                    <th
                      style={{
                        border: "1px solid black",
                        padding: "5px",
                        textAlign: "center",
                      }}
                    >
                      Date
                    </th>
                    <th
                      style={{
                        border: "1px solid black",
                        padding: "5px",
                        textAlign: "center",
                      }}
                    >
                      MDA Code
                    </th>
                    <th
                      style={{
                        border: "1px solid black",
                        padding: "5px",
                        textAlign: "center",
                      }}
                    >
                      Economic Code
                    </th>
                    <th
                      style={{
                        border: "1px solid black",
                        padding: "5px",
                        textAlign: "center",
                      }}
                    >
                      Description
                    </th>
                    <th
                      style={{
                        border: "1px solid black",
                        padding: "5px",
                        textAlign: "center",
                      }}
                    >
                      Program Code
                    </th>
                    <th
                      style={{
                        border: "1px solid black",
                        padding: "5px",
                        textAlign: "center",
                      }}
                    >
                      Amount (₦)
                    </th>
                    <th
                      style={{
                        border: "1px solid black",
                        padding: "5px",
                        textAlign: "center",
                      }}
                    >
                      Status
                    </th>
                    <th
                      style={{
                        border: "1px solid black",
                        padding: "5px",
                        textAlign: "center",
                      }}
                    >
                      Approval no
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {data.map((item, index) => (
                    <tr key={index}>
                      <td
                        style={{
                          border: "1px solid black",
                          padding: "3px",
                          fontSize: "8px",
                        }}
                      >
                        {moment(item.approval_date).format("DD-MM-YYYY")}
                      </td>
                      <td
                        style={{
                          border: "1px solid black",
                          padding: "3px",
                          fontSize: "8px",
                        }}
                      >
                        {item.mda_code}
                      </td>
                      <td
                        style={{
                          border: "1px solid black",
                          padding: "3px",
                          fontSize: "8px",
                        }}
                      >
                        {item.economic_code}
                      </td>
                      <td
                        style={{
                          border: "1px solid black",
                          padding: "3px",
                          fontSize: "8px",
                        }}
                      >
                        {item.description_code}
                      </td>
                      <td
                        style={{
                          border: "1px solid black",
                          padding: "3px",
                          fontSize: "8px",
                        }}
                      >
                        {item.program_code || "---"}
                      </td>
                      <td
                        style={{
                          border: "1px solid black",
                          padding: "3px",
                          textAlign: "right",
                          fontSize: "8px",
                        }}
                      >
                        {formatNumber(ensureNumber(item.amount))}
                      </td>
                      <td
                        style={{
                          border: "1px solid black",
                          padding: "3px",
                          textAlign: "right",
                          fontSize: "8px",
                        }}
                      >
                        {formatNumber(ensureNumber(item.approval_status))}
                      </td>
                      <td
                        style={{
                          border: "1px solid black",
                          padding: "3px",
                          textAlign: "right",
                          fontSize: "8px",
                        }}
                      >
                        {formatNumber(ensureNumber(item.approval_no))}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              {/* Footer */}
              <div
                style={{
                  marginTop: "30px",
                  textAlign: "center",
                  fontSize: "10px",
                }}
              >
                <div>Generated on: {moment().format("DD-MM-YYYY HH:mm")}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <DashboardLayout>
      {form.mda_name && (
        <center>
          <h2>{/* {form.mda_code} - {form.mda_name} */}</h2>
        </center>
      )}
      {showBulkPreview ? (
        renderBulkPreview()
      ) : (
        <MDBox pt={1} pb={3}>
          <Grid container spacing={6}>
            <Grid item xs={12}>
              <Card>
                <MDBox
                  mx={2}
                  mt={-3}
                  py={3}
                  px={2}
                  variant="gradient"
                  bgColor="success"
                  borderRadius="lg"
                  coloredShadow="info"
                >
                  <MDTypography
                    variant="h5"
                    color="white"
                    className="text-center"
                  >
                    Releases Report
                  </MDTypography>
                </MDBox>
                {/* <div className="">
                <Button
                  color="primary"
                  className="pr-5 pl-5 m-4"
                  style={{ float: "right" }}
                  onClick={() => toggle3()}
                >
                  Add New Proposal
                </Button>
              </div> */}

                <MDBox>
                  <MDBox pt={0}>
                    <div className=" row p-3">
                      <div className="col-md-4 mb-3">
                        <CustomTypeahead
                          labelKey="head"
                          label="Select MDA"
                          options={aheadData}
                          onChange={(s) => {
                            if (s.length) {
                              setForm((p) => ({
                                ...p,
                                mda_code: s[0].code,
                                mda_name: s[0].description,
                              }));
                            } else {
                              setForm((p) => ({
                                ...p,
                                mda_code: "",
                                mda_name: "",
                              }));
                            }
                          }}
                        />
                      </div>
                      <div className="col-md-3">
                        <Label></Label>
                        <SearchBar
                          placeholder="Search By code or description"
                          filterText={searchText}
                          onChange={handleSearchChange}
                        />
                      </div>
                      {/* <div className="col-md-3 mb-3">
                        <label>Budget Type</label>
                        <select
                          name="approval_type"
                          onChange={handleChange}
                          className="form-control"
                          value={form.approval_type}
                        >
                          <option value="">...Select...</option>
                          <option value="Revenue">Recurrent</option>
                          <option value="Capital">Capital</option>
                        </select>
                      </div> */}
                      {/* {JSON.stringify({ query_type })} */}
                      <div className="col-md-3">
                        <Label>Date From</Label>
                        <Input
                          type="date"
                          value={form.date_from}
                          name="date_from"
                          onChange={handleChanges}
                        />
                      </div>
                      <div className="col-md-2">
                        <Label>Date To</Label>
                        <Input
                          type="date"
                          value={form.date_to}
                          name="date_to"
                          onChange={handleChanges}
                        />
                      </div>
                      <div className="row">
                        <div className="col-md-8">
                          <span style={{ marginRight: "15px" }}>
                            <b>TOTAL AMOUNT : </b> ₦{total?.toLocaleString()}
                          </span>
                          {/* <span style={{ marginRight: "15px" }}>
                            <b>TOTAL CR : </b> ₦{totalCR?.toLocaleString()}
                          </span>
                          <span style={{ marginRight: "15px" }}>
                            <b>TOTAL MOPB CR : </b> ₦
                            {totalMOPBCR?.toLocaleString()}
                          </span> */}
                        </div>
                        <div className="col-md-4">
                          <Button
                            color="success"
                            className="mt-0"
                            onClick={handleBulkPreview}
                            disabled={isPrinting || data.length === 0}
                            style={{
                              fontWeight: 500,
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                              float: "right",
                            }}
                          >
                            {isPrinting ? (
                              <>
                                <Spinner size="sm" />
                                Loading...
                              </>
                            ) : (
                              <>
                                <FaEye size="16px" />
                                Preview Report ({data.length})
                              </>
                            )}
                          </Button>
                        </div>
                      </div>

                      {loading && (
                        <div className="loading-container text-center">
                          <Spinner
                            color="primary"
                            style={{ marginTop: "20px" }}
                          />{" "}
                          Loading...
                        </div>
                      )}
                      {/* {JSON.stringify(data)} */}
                      <Scrollbar>
                        <CustomTable
                          fields={fields}
                          data={data}
                          type="approve"
                        />
                      </Scrollbar>
                    </div>
                  </MDBox>
                </MDBox>
              </Card>
            </Grid>
          </Grid>
        </MDBox>
      )}
      <Footer />
    </DashboardLayout>
  );
}

export default ReleaseReport;
